import { Observable, Subscription } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { UntypedFormBuilder } from '@angular/forms';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef } from '@angular/material/dialog';

import { ConfirmDialogComponent, ConfirmDialogInterface } from '@components/dialogs/confirm-dialog/confirm-dialog.component';
import { MatriculaGestaoModel } from '@models/gestao/matricula-gestao.model';
import { Router } from '@angular/router';
import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { CartItemModel } from '@models/outros/cart.model';
import { CartModel } from '@models/outros/cart.model';
import { ShoppingCartService } from '@services/outros/shopping-cart.service';

@Component({
  selector: 'app-sales-dialog',
  templateUrl: './sales-dialog.component.html',
  styleUrls: ['./sales-dialog.component.scss']
})
export class SalesDialogComponent {

  productsForm: UntypedFormGroup;
  dataSource: Observable<CartModel>;
  dataSourceProducts: MatTableDataSource<CartItemModel> = new MatTableDataSource<CartItemModel>();
  displayedColumns: string[] = ['descricao', 'valorPadrao', 'quantidade']
  matricula: MatriculaGestaoModel;
  private _subscription: Subscription;

  constructor(
    private _dialogRef: MatDialogRef<SalesDialogComponent>,
    private _dialog: MatDialog,
    private _formBuilder: UntypedFormBuilder,
    private _shoppingCartService: ShoppingCartService,
    private _router: Router,
  ) {
    this._subscription = new Subscription();

  }

  ngOnInit(): void {
    this.matricula = this._shoppingCartService.getCandidate();
    this._getCart();
    this._initForm();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  add(element): void {
    element.quantidade++;
  }

  checkout(): void {
    this._dialogRef.disableClose = true;
    this._router.navigate([`/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.shoppingCart}`]);
  }

  clearCart(): void {
    this._shoppingCartService.clearCart();
  }

  getTotal(): number {
    let total = 0;
    this.dataSourceProducts.data.forEach(
      (element) => {
        const valor = element.quantidade * element.produto.valorMinimo;
        total += valor;
      }
    )
    return total;
  }

  regularize(): void {
    this._shoppingCartService.clearCart();
    this._router.navigate([`/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.enrollment}/${ROUTES_APLICATION.detail}`, this.matricula.id]);
  }

  remove(item: CartItemModel): void {
    if (this._shoppingCartService.checkQuantityIsZero(item.produto)) {
      this._subscription.add(
        this._dialog.open<ConfirmDialogComponent, ConfirmDialogInterface>(ConfirmDialogComponent, {
          data: {
            title: 'Remover produto',
            subtitle: 'Ao setar a quantidade de um produto para zero, você ira remove-lo do carrinho de compras.',
            descriptionFirst: `Tem certeza que deseja remover o item:`,
            descriptionSecond: `${item.produto.descricao}`
          }
        }).afterClosed().subscribe(
          (res) => {
            if (res) {
              this._removeItem(item);
            }
          }
        )
      )
    } else {
      this._removeItem(item);
    }
  }

  updateValue(element): void {
    setTimeout(() => {
      const quantity = this.productsForm.get(`${element.id}`).value;
      if (quantity > 0) {
        element.quantidade = quantity;
      } else if (quantity === 0) {
        this._removeItem(element)
      } else {
        element.quantity = 0;
      }
    }, 100);
  }

  private _getCart(): void {
    this._subscription.add(
      this._shoppingCartService.getCartSubject().subscribe(
        (res) => this.dataSourceProducts.data = res.venda
      )
    )
  }

  private _initForm(): void {
    this.productsForm = this._formBuilder.group({});
    this.dataSourceProducts.data
      .forEach(control => {
        const index = this.dataSourceProducts.data.indexOf(control).toString();
        this.productsForm.addControl(index, this._formBuilder.control(control.quantidade))
      });
  }

  private _removeItem(item: CartItemModel): void {
    this._shoppingCartService.removeProduct(item.produto);
    this.dataSourceProducts.data = this._shoppingCartService.getCart().venda;
  }
}
